import { ICustomField } from '@models/CustomField.model';
import {
  ChildrenT,
  customFieldIdPrefix,
  customFieldTypePrefix,
  getNextPrev,
  IHeadingChildren,
  IHeadings,
} from './HeadingsCalc';

export function createFromCustomFields(
  customFields: ICustomField[],
  pages: IHeadings,
) {
  const mapToSet = new Map(pages);
  const customFieldHeading = mapToSet.get('Custom Data');
  if (!customFieldHeading || customFields.length === 0) return null;
  const { id } = customFieldHeading;
  // make children entries
  const childrenEntries = customFields.map((field, index, array) => {
    const { next, prev } = getNextPrev(array, index);
    const headingId: ChildrenT = `${customFieldIdPrefix}${field.id}`;

    const nextId: ChildrenT | null = next
      ? `${customFieldIdPrefix}${next.id}`
      : null;
    const prevId: ChildrenT | null = prev
      ? `${customFieldIdPrefix}${prev.id}`
      : null;
    return [
      headingId,
      {
        id: headingId,
        name: field.name,
        inputType: `${customFieldTypePrefix}${field.type}`,
        nextId,
        prevId,
        parentId: id,
      },
    ] as [string, IHeadingChildren];
  });
  // Link children to parent.
  const childrenMap = new Map(childrenEntries);
  mapToSet.set(id, { ...customFieldHeading, children: childrenMap });
  return mapToSet;
}
